module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground_portrait@3x.jpg?1.0.17";